var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVersionHistory = function SvgVersionHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 9.497v-5.29c0-.45.54-.67.85-.35l1.78 1.78a9.01 9.01 0 0 1 7.21-2.6c4.19.38 7.64 3.75 8.1 7.94a9 9 0 0 1-17.87 2.14c-.07-.6.4-1.12 1-1.12.5 0 .92.37.98.86.43 3.49 3.44 6.19 7.05 6.14 3.71-.05 6.84-3.18 6.9-6.9.06-3.9-3.11-7.1-7-7.1-1.93 0-3.68.79-4.95 2.05l2.09 2.09c.32.32.1.86-.35.86H3.5c-.28 0-.5-.22-.5-.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.997 12.427v-3.68c0-.41.34-.75.75-.75s.75.34.76.74v3.4l2.87 1.71c.36.21.47.67.26 1.03-.21.35-.67.47-1.03.26l-3.12-1.85c-.3-.18-.49-.51-.49-.86"
  })));
};
export default SvgVersionHistory;